module.exports = __webpack_public_path__ + "media/NotificationVideo.58218f9c.mp4";